import { createReducer } from '@reduxjs/toolkit';
import { lifecycleSurveyDoNotContactListActions } from '~/behaviors/actions/lifecycleSurveyDoNotContactList.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { TransformedLifecycleSurveyDoNotContactList } from '~/behaviors/transformers/lifecycleSurveyDoNotContactList.transformer';

const defaultState = {};

const reset = () => defaultState;

const merge = (state, { payload }) => {
  const entries = payload?.entities?.lifecycleSurveyDoNotContactList as Record<
    number,
    TransformedLifecycleSurveyDoNotContactList
  >;
  if (!entries) return;

  Object.values(entries).forEach((entry) => {
    state[entry.id] = { ...state[entry.id], ...entry };
  });
};

const remove = (state, { payload }) => {
  const id = payload?.id;
  if (!id) return state;

  const { [id]: deleted, ...rest } = state;

  return rest;
};

const lifecycleSurveyDoNotContactList = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(lifecycleSurveyDoNotContactListActions.getLifecycleSurveyDoNotContactList.fulfilled, merge)
    .addCase(lifecycleSurveyDoNotContactListActions.deleteFromLifecycleDoNotContactList.fulfilled, remove);
});

export default lifecycleSurveyDoNotContactList;
